import { combineReducers } from "redux";
import authReducer from "../features/auth/store/authSlice";

const rootReducer = combineReducers({
  auth: authReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
